export class BltSignatureField {
  static readonly SIGNATURE: string = "Signature";
  static readonly ADD_YOUR_SIGNATURE: string = "Add your signature";
  static readonly EDIT: string = "Edit";
  static readonly SAVE: string = "Save";
  static readonly ADD_SIGNATURE: string = "Add signature";
  static readonly VIEW_SIGNATURE: string = "View signature";
  static readonly DRAW_SIGN_MSG: string = "Draw your signature above";
}
